var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2539 8.05957C15.2539 12.2017 11.8958 15.5596 7.75391 15.5596C3.61197 15.5596 0.253906 12.2017 0.253906 8.05957C0.253906 3.91745 3.61197 0.55957 7.75391 0.55957C11.8958 0.55957 15.2539 3.91745 15.2539 8.05957ZM6.37523 13.8875V10.8232C6.04976 9.66339 4.98424 8.81301 3.72029 8.81301H1.81329C2.12595 11.3053 3.97092 13.3209 6.37523 13.8875ZM2.04126 6.26049C2.80495 3.83282 5.07386 2.07218 7.75391 2.07218C10.434 2.07218 12.7029 3.83282 13.4666 6.26049H2.04126ZM13.6945 8.81301H11.6851C10.4212 8.81301 9.35563 9.66339 9.03017 10.8232V13.9107C11.4842 13.3779 13.3774 11.3405 13.6945 8.81301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryDriver);
export default __webpack_public_path__ + "static/media/summary-driver.7162f01b11d26726ca77ff465bc9b900.svg";
export { ForwardRef as ReactComponent };